module.exports = __webpack_public_path__ + "750a28e99d0cf3b07b2aeb9337d3cabd.png";